class LayoutSwitch extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleLayoutToggle = this.handleLayoutToggle.bind(this)

    this.listeners.add(
      this.els.toggle.element,
      'click',
      this.handleLayoutToggle,
    )
  }

  async handleLayoutToggle () {
    const listClass = `clc-ProductGrid`

    const viewportMode = window.BAO.MediaBreakpoints.isSm
      ? 'desktop'
      : 'mobile'
    const currentLayout =
      viewportMode === 'desktop'
        ? this.dataset.desktopLayout
        : this.dataset.mobileLayout

    const newLayout =
      currentLayout === 'Standard'
        ? 'Wall'
        : currentLayout === 'Wall'
          ? 'Centered'
          : 'Standard'

    this.externalEls.grid.element.setAttribute('aria-busy', 'true')

    if (viewportMode === 'desktop') {
      await window.BAO.Cart.updateCartAttributes({
        desktop_layout: newLayout,
      })
    } else {
      await window.BAO.Cart.updateCartAttributes({
        mobile_layout: newLayout,
      })
    }

    this.setAttribute(`data-${viewportMode}-layout`, newLayout)

    if (this.dataset.desktopLayout === 'Centered') {
      this.externalEls.cursor.element.setAttribute(
        'data-custom-cursor-external-el',
        'scroll',
      )
    } else {
      this.externalEls.cursor.element.removeAttribute(
        'data-custom-cursor-external-el',
      )
    }

    window.setTimeout(() => {
      this.externalEls.grid.element.classList.remove(
        `${listClass}-${viewportMode}${currentLayout}`,
      )
      this.externalEls.grid.element.classList.add(
        `${listClass}-${viewportMode}${newLayout}`,
      )

      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant',
      })
      this.externalEls.grid.element.setAttribute('aria-busy', 'false')
    }, 100)
  }
}

if (!customElements.get('layout-switch')) {
  customElements.define('layout-switch', LayoutSwitch)
}
